// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.buy_a_vehicle_card[data-v-73ec4658] {
  padding: 0 5px;
}
.buy_a_vehicle_card .ft-small[data-v-73ec4658] {
  font-size: 0.75vw;
}
.buy_a_vehicle_card .opacity-7[data-v-73ec4658] {
  opacity: 0.7;
}
.buy_a_vehicle_card .table-borderless > tbody > tr > td[data-v-73ec4658],
.buy_a_vehicle_card .table-borderless > tbody > tr > th[data-v-73ec4658],
.buy_a_vehicle_card .table-borderless > tfoot > tr > td[data-v-73ec4658],
.buy_a_vehicle_card .table-borderless > tfoot > tr > th[data-v-73ec4658],
.buy_a_vehicle_card .table-borderless > thead > tr > td[data-v-73ec4658],
.buy_a_vehicle_card .table-borderless > thead > tr > th[data-v-73ec4658] {
  border: none;
  padding: 5px;
  font-size: 0.73vw;
  font-weight: 500;
}
.buy_a_vehicle_card table.table-borderless tr td[data-v-73ec4658] {
  max-width: 0;
}
.buy_a_vehicle_card table.table-borderless tr td[data-v-73ec4658]:first-child {
  opacity: 0.6;
}
.border_right[data-v-73ec4658] {
  display: block;
  width: 100%;
  height: 2px;
  background: #eee;
  position: relative;
  top: 2px;
}
.custom_legend[data-v-73ec4658] {
  font-size: 0.8vw;
  font-weight: bold;
}
.animate_bottom[data-v-73ec4658] {
  animation: animateBottom-73ec4658 2s;
  transition: 0.5s;
}
.disclaimer[data-v-73ec4658] {
  text-decoration: underline;
  cursor: pointer;
  font-size: 0.73vw;
}
@keyframes animateBottom-73ec4658 {
0% {
    transform: translateY(50px);
}
100% {
    transform: translateY(0);
}
}
`, "",{"version":3,"sources":["webpack://./src/Components/ChatWidget/SlideOutPanel/TvmSlideOutBuyVehicle/TvmUserInfo.vue","webpack://./TvmUserInfo.vue"],"names":[],"mappings":"AACA;EACE,cAAA;ACAF;ADDA;EAII,iBAAA;ACAJ;ADJA;EAQI,YAAA;ACDJ;ADPA;;;;;;EAiBI,YAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;ACFJ;ADlBA;EAwBI,YAAA;ACHJ;ADrBA;EA4BI,YAAA;ACJJ;ADQA;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;ACNF;ADSA;EACE,gBAAA;EACA,iBAAA;ACPF;ADUA;EACE,oCAAA;EACA,gBAAA;ACRF;ADWA;EACE,0BAAA;EACA,eAAA;EACA,iBAAA;ACTF;ADYA;AACE;IACE,2BAAA;ACVF;ADaA;IACE,wBAAA;ACXF;AACF","sourcesContent":["\n.buy_a_vehicle_card {\n  padding: 0 5px;\n\n  .ft-small {\n    font-size: 0.75vw;\n  }\n\n  .opacity-7 {\n    opacity: 0.7;\n  }\n\n  .table-borderless>tbody>tr>td,\n  .table-borderless>tbody>tr>th,\n  .table-borderless>tfoot>tr>td,\n  .table-borderless>tfoot>tr>th,\n  .table-borderless>thead>tr>td,\n  .table-borderless>thead>tr>th {\n    border: none;\n    padding: 5px;\n    font-size: 0.73vw;\n    font-weight: 500;\n  }\n\n  table.table-borderless tr td {\n    max-width: 0;\n  }\n\n  table.table-borderless tr td:first-child {\n    opacity: 0.6;\n  }\n}\n\n.border_right {\n  display: block;\n  width: 100%;\n  height: 2px;\n  background: #eee;\n  position: relative;\n  top: 2px;\n}\n\n.custom_legend {\n  font-size: 0.8vw;\n  font-weight: bold;\n}\n\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n\n.disclaimer {\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.73vw;\n}\n\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n\n  100% {\n    transform: translateY(0);\n  }\n}\n",".buy_a_vehicle_card {\n  padding: 0 5px;\n}\n.buy_a_vehicle_card .ft-small {\n  font-size: 0.75vw;\n}\n.buy_a_vehicle_card .opacity-7 {\n  opacity: 0.7;\n}\n.buy_a_vehicle_card .table-borderless > tbody > tr > td,\n.buy_a_vehicle_card .table-borderless > tbody > tr > th,\n.buy_a_vehicle_card .table-borderless > tfoot > tr > td,\n.buy_a_vehicle_card .table-borderless > tfoot > tr > th,\n.buy_a_vehicle_card .table-borderless > thead > tr > td,\n.buy_a_vehicle_card .table-borderless > thead > tr > th {\n  border: none;\n  padding: 5px;\n  font-size: 0.73vw;\n  font-weight: 500;\n}\n.buy_a_vehicle_card table.table-borderless tr td {\n  max-width: 0;\n}\n.buy_a_vehicle_card table.table-borderless tr td:first-child {\n  opacity: 0.6;\n}\n.border_right {\n  display: block;\n  width: 100%;\n  height: 2px;\n  background: #eee;\n  position: relative;\n  top: 2px;\n}\n.custom_legend {\n  font-size: 0.8vw;\n  font-weight: bold;\n}\n.animate_bottom {\n  animation: animateBottom 2s;\n  transition: 0.5s;\n}\n.disclaimer {\n  text-decoration: underline;\n  cursor: pointer;\n  font-size: 0.73vw;\n}\n@keyframes animateBottom {\n  0% {\n    transform: translateY(50px);\n  }\n  100% {\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
